require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.3@core-js/library/fn/get-iterator.js
// module id = 202
// module chunks = 1